import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';

export const unauthenticatedGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const oktaAuth = inject(OKTA_AUTH) as OktaAuth;

  const isAuthenticated = await oktaAuth.isAuthenticated();

  if (isAuthenticated) {
    router.navigate(['/home']);
    return false;
  } else {
    try {
      const exists = await oktaAuth.session.exists();
      if (exists) {
        const tokenResponse = await oktaAuth.token.getWithoutPrompt({
          scopes: ['openid', 'profile', 'email', 'offline_access'],
        });
        oktaAuth.tokenManager.setTokens(tokenResponse.tokens);
        router.navigate(['/home']);
        return false;
      } else {
        console.log("User is not authenticated");
        return true;
      }
    } catch (error) {
      console.error('Silent SSO failed');
      return true;
    }
  }

  return true;
};
